<template>
  <b-container class="my-5">
    <AskEndTraining
      :open="showAskEndTraining"
      @hide="showAskEndTraining = false"
      @ok="endTraining"
      v-bind="{ events }"
    />
    <template
      v-if="
        showPlaylist && playlist && playlist.videos && playlist.videos.length
      "
    >
      <Playlist
        :visible="showPlaylist"
        :autoplay="true"
        :videos="playlist.videos"
        @close="askEndTraining"
        @finished="askEndTraining"
        @event="addEvent"
      />
    </template>
    <rate-playlist
      :open="isRateModalOpen"
      :playlist="playlist"
      @close="isRateModalOpen = false"
    />

    <b-row>
      <b-col lg="6">
        <b-row>
          <b-col class="small text-muted">{{ playlist.tagline }}</b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col>
            <ProgrammTitle :loading="loading" :title="playlist.title" />
          </b-col>
          <b-col cols="1">
            <FavIndicator
              :playlistId="playlist.id"
              :isFavourite="playlist.isFavourite"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <ProgrammDescription
              :loading="loading"
              :description="playlist.description"
            />
          </b-col>
        </b-row>
      </b-col>
      <b-col
        v-if="['xl', 'lg', 'md'].includes($mq)"
        lg="3"
        md="6"
        class="border-right"
      >
        <template
          v-for="dimension in [
            'strength',
            'endurance',
            'mobility',
            'coordination',
          ]"
        >
          <b-row
            v-if="playlist && playlist.radar"
            :key="dimension"
            class="mt-3"
            style="min-height: 28px;"
          >
            <b-col cols="5">{{ $t(`dimension_${dimension}`) }}</b-col>
            <b-col cols="7">
              <b-progress
                :value="playlist.radar[dimension] * 10"
                :max="10"
                variant="green"
              />
            </b-col>
          </b-row>
        </template>
      </b-col>
      <b-col xs="12" md="6" lg="3">
        <b-row>
          <b-col>
            <ProgrammMeta
              :loading="loading"
              :areas="playlist.areas"
              :resources="playlist.resources"
              :duration="playlist.duration"
            />
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col :cols="5">{{ $t('PAGE_playlist_rating') }}</b-col>
          <b-col :cols="7">
            <b-button
              :variant="
                !playlist || loading ? 'outline-light2' : 'outline-grey'
              "
              :disabled="!playlist || loading"
              size="sm"
              @click="isRateModalOpen = true"
              >{{ $t('PAGE_playlist_rate_plalist') }}</b-button
            >
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row class="my-5">
      <b-col class="text-center">
        <b-form-group
          label-for="goToProgramm"
          :description="
            playlist.lastFinishDate
              ? $t('last_trained', {
                  date: $moment(playlist.lastFinishDate).fromNow(),
                })
              : loading
              ? ''
              : $t('never_trained')
          "
        >
          <b-button
            :variant="!playlist || loading ? 'outline-light2' : 'green'"
            class="w-100"
            :disabled="!playlist || loading"
            @click="showPlaylist = true"
            >{{ $t('PAGE_playlist_start_training') }}</b-button
          >
        </b-form-group>
      </b-col>
    </b-row>

    <ProgrammVideos :loading="loading" :videos="playlist.videos" />
  </b-container>
</template>

<script>
import { find } from 'lodash/fp';
import { mapGetters, mapState } from 'vuex';
import Playlist from '@/components/Playlist';
import ProgrammTitle from '@/elements/ProgrammTitle';
import ProgrammDescription from '@/elements/ProgrammDescription';
import ProgrammVideos from '@/elements/ProgrammVideos';
import ProgrammMeta from '@/elements/ProgrammMeta';
import RatePlaylist from '@/components/modals/RatePlaylist';
import AskEndTraining from '@/components/modals/AskEndTraining';
import LoadingLine from '@/elements/LoadingLine';
import FavIndicator from '@/elements/FavIndicator';

import router from '@/router';

export default {
  name: 'playlistPage',
  components: {
    Playlist,
    RatePlaylist,
    ProgrammTitle,
    ProgrammDescription,
    ProgrammVideos,
    ProgrammMeta,
    AskEndTraining,
    LoadingLine,
    FavIndicator,
  },
  data() {
    return {
      showPlaylist: false,
      isRateModalOpen: false,
      showAskEndTraining: false,
      events: [],
    };
  },
  asyncData({ store, route }) {
    return store.dispatch('getPlaylist', route.params.id).catch(error => {
      if (!store.getters.isLoggedIn) {
        store.dispatch('openLoginModal');
      } else {
        router.push({ name: '404' });
      }
    });
  },
  watch: {
    // In case the user logs in when seeing a playlist, we need to refetch it (favs, last played,...)
    isLoggedIn: function(isLoggedIn) {
      if (isLoggedIn) {
        this.$store.dispatch('getPlaylist', this.playlistId).catch(error => {
          router.push({ name: '404' });
        });
      }
    },
  },
  computed: {
    ...mapGetters(['isLoggedIn', 'playlists']),
    ...mapState({
      loading: state => state.api.pending.playlists,
    }),
    playlistId() {
      return parseInt(this.$route.params.id, 10);
    },
    playlist() {
      return find({ id: this.playlistId }, this.playlists) || {};
    },
  },
  methods: {
    addEvent(event) {
      if (this.showPlaylist) {
        this.events.push(event);
      }
    },
    askEndTraining() {
      this.events.push({
        timestamp: new Date(),
        event: 'requestEnd',
      });
      this.showAskEndTraining = true;
    },
    endTraining({ q1, q2, q3 }) {
      if (this.isLoggedIn)
        this.$store
          .dispatch('finishPlaylist', {
            params: { id: this.playlistId },
            data: { events: this.events, q1, q2, q3 },
          })
          .then(() => {
            this.events = [];
          });

      this.showPlaylist = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Playlist.vue